import moment from 'moment'
import React from 'react'
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom'
import { MdArrowForwardIos } from 'react-icons/md'
import NoDataFound from '../../NoDataFound';
import { useSelector } from 'react-redux';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
 
const LatestResult = ({ modules, loading }) => {
    const userData = useSelector((state) => state.userSlice);
    var navigate = useNavigate();
    

    const handleMyLearning = (event, e) => {
        event.stopPropagation();
        navigate(`/course/details/${e.uuid}`, {
          state: {
            name: e.name || "",
            userUUID: userData?.user?.uuid || "",
            previousLocationPathname: null,
          },
        });
      };

    return (
        <>  
            <div className="cardbox h-100">
                <h5 className='mb-2'>{loading ? <Skeleton width="5vw" /> : <> Recent Courses </> }</h5>
                <div className='latestresult'>
                {loading ? 
                <>
                <div className='cardboxdata borderleft' style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} >
                        <div style={{ width: "60%" }}>            
                        <h6><Skeleton width="15vw" /></h6>          
                        <p><Skeleton width="10vw" /></p>   
                        <div className="progress">
                        <Skeleton width="100%" baseColor="#333" highlightColor="#ffffff50" />
                        </div> 
                        </div>
                        <button className='btn btn-sm btn-danger mb-0'>  <Skeleton width="100px" baseColor="#3e4095" highlightColor="#ffffff50"/></button>
                </div>
                <div className='cardboxdata borderleft' style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} >
                        <div style={{ width: "60%" }}>            
                        <h6><Skeleton width="15vw" /></h6>          
                        <p><Skeleton width="10vw" /></p>   
                        <div className="progress">
                        <Skeleton width="100%" baseColor="#333" highlightColor="#ffffff50" />
                        </div> 
                        </div>
                        <button className='btn btn-sm btn-danger mb-0'>  <Skeleton width="100px" baseColor="#3e4095" highlightColor="#ffffff50"/></button>
                </div>
                <div className='cardboxdata borderleft' style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} >
                        <div style={{ width: "60%" }}>            
                        <h6><Skeleton width="15vw" /></h6>          
                        <p><Skeleton width="10vw" /></p>   
                        <div className="progress">
                        <Skeleton width="100%" baseColor="#333" highlightColor="#ffffff50" />
                        </div> 
                        </div>
                        <button className='btn btn-sm btn-danger mb-0'>  <Skeleton width="100px" baseColor="#3e4095" highlightColor="#ffffff50"/></button>
                </div>
                </>
                :
                <>
                    {modules.map ? 

                    <>

                    {modules.map((item, index) => {
                    return (
                    // <div className='cardboxdata borderleft' style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} key={index} onClick={() => navigate(`/course/details/${item.uuid}`, { state: { name: item.name || "" } })}>
                    <div className='cardboxdata borderleft' style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} key={index} onClick={(event) => handleMyLearning(event, item)}>
                        <div style={{ width: "60%" }}>
                        <Tooltip title={item.name}> 
                        <h6>{item.name}</h6>
                        </Tooltip>
                        { item.progress ? item.lastSession && <p>{moment(item.lastSession.startTime).fromNow()}</p> : <p>No Progress</p> }

                        {item.progress ?
                        <div className="progress">
                            <div className="progress-bar" role="progressbar" style={{ width: `${item.progress}%` }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{item.progress}%</div>
                        </div> : null}

                        </div>

                        <button className='btn btn-sm btn-primary mb-0'> { item.progress ? item.progress == 100 ? "Start again" : "Continue" : "Start Course" }  <MdArrowForwardIos /> </button>
                      </div> )
                    })}
                    </>
                    :
                    <>
                    <div className='d-flex align-items-center justify-content-center'>
                    <NoDataFound nodatatext={"No Courses assigned"}/>
                    </div>
                  
                    </>
                    }
                    </> }
                </div>
            </div>
        </>
    )
}

export default LatestResult
